<div class="">
  <!-- <ng-container *ngIf="description && !isEditDescription">
    <div class="text-gray-600 mb-1">
      <span>Description</span>
    </div>
  </ng-container> -->
  <div *ngIf="isEditorPending" class="rich-text-box-loading text-sm text-gray-400">Loading editor...</div>
  <div class="text-area" [class.no-height]="!isEditDescription" [class.hidden]="isEditorPending">
    <textarea
      #descriptionTextarea
      class="w-full"
      [class.rich-text-box-fallback]="isFallbackMode"
      (input)="onFallbackInput()"
      (blur)="onFallbackBlur()"
    ></textarea>
  </div>
</div>
